module.exports = __webpack_public_path__ + "img/15.134bd795.jpg";